export const CONTACT_LIST = 1
export const POWER_DIALER_LIST = 2
export const PUBLIC_CONTACT_LIST = 3